import { useState } from "react";
import { OverwriteMenuModal } from "./OverwriteMenuModal";
import { ButtonPrimary } from "../../../components/NewButtons";

export const OverwriteMenuSelector = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <ButtonPrimary onClick={() => setIsOpen(true)}>
        Create menu schedule
      </ButtonPrimary>
      <OverwriteMenuModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
